import { useCallback } from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useUser } from 'contexts';
import { getLastPurchaseChallanDaybook } from '../redux/actions/PurchaseChallan';
import moment from 'moment';
import { getFinancialYears } from '../redux/actions/dashboard';

const usePurchaseChallanLastDaybook = () => {
   const [selectedDaybookId, setSelectedDaybookId] = useState(null);
   const { user } = useUser();
   const dispatch = useDispatch();
   const lastPurchaseDaybook = useSelector((state) => state.purchaseChallan?.lastPurchaseDaybook);
   const financialYears = useSelector((state) => state?.dashboard?.financialYears);
   const financialYear = financialYears?.find((a) => a.financial_year === user?.financialYear);

   const getLastDaybook = useCallback(async () => {
      if (user && user?.loginhistory?.companyId) {
         await dispatch(getFinancialYears({ companyId: user?.loginhistory?.companyId }));
         const fromDate = moment(financialYear?.fy_start_date, 'DD/MM/YYYY').format('YYYY-MM-DD');
         const toDate = moment(financialYear?.fy_end_date, 'DD/MM/YYYY').format('YYYY-MM-DD');

         const params = {
            companyId: user.loginhistory.companyId,
            fromDate,
            toDate,
            ...(selectedDaybookId && { daybookId: selectedDaybookId }),
         };
         await dispatch(getLastPurchaseChallanDaybook(params));
      }
   }, [dispatch, selectedDaybookId, user]);

   useEffect(() => {
      getLastDaybook();
   }, [getLastDaybook]);

   return {
      lastPurchaseDaybook,
      setSelectedDaybookId,
   };
};

export default usePurchaseChallanLastDaybook;
